import { token } from '@atlaskit/tokens';
import { defineMessage } from '@atlassian/jira-intl';
import type { BackgroundColorMeta } from './types.tsx';

const grey = defineMessage({
	id: 'system-announcement-banner-main.settings.form.background-picker.grey',
	defaultMessage: 'Grey',
	description: 'Tooltip text for grey color',
});

const purple = defineMessage({
	id: 'system-announcement-banner-main.settings.form.background-picker.purple',
	defaultMessage: 'Purple',
	description: 'Tooltip text for purple color',
});

const green = defineMessage({
	id: 'system-announcement-banner-main.settings.form.background-picker.green',
	defaultMessage: 'Green',
	description: 'Tooltip text for green color',
});

const yellow = defineMessage({
	id: 'system-announcement-banner-main.settings.form.background-picker.yellow',
	defaultMessage: 'Yellow',
	description: 'Tooltip text for yellow color',
});

const red = defineMessage({
	id: 'system-announcement-banner-main.settings.form.background-picker.red',
	defaultMessage: 'Red',
	description: 'Tooltip text for red color',
});

export const GREY_META: BackgroundColorMeta = {
	name: 'grey',
	messageLabel: grey,
	color: token('color.background.neutral.bold'),
	textColor: token('color.text.inverse'),
};
const PURPLE_META: BackgroundColorMeta = {
	name: 'purple',
	messageLabel: purple,
	color: token('color.background.discovery.bold'),
	textColor: token('color.text.inverse'),
};
const GREEN_META: BackgroundColorMeta = {
	name: 'green',
	messageLabel: green,
	color: token('color.background.success.bold'),
	textColor: token('color.text.inverse'),
};
const YELLOW_META: BackgroundColorMeta = {
	name: 'yellow',
	messageLabel: yellow,
	color: token('color.background.warning.bold'),
	textColor: token('color.text.warning.inverse'),
};
const RED_META: BackgroundColorMeta = {
	name: 'red',
	messageLabel: red,
	color: token('color.background.danger.bold'),
	textColor: token('color.text.inverse'),
};

export const BACKGROUND_THEMES: BackgroundColorMeta[] = [
	GREY_META,
	PURPLE_META,
	GREEN_META,
	YELLOW_META,
	RED_META,
];
